import { geoRecordId } from "../gi-registry/geoPath";
import { workflowLabel } from "./orderStatus";

export type StudioOrderOption = {
  value: string;
  label: string;
  code: string;
  customerName: string;
  productDesign: string;
  colours: string;
  status: string;
  dueDate: string;
  orgName: string;
};

export const coloursFromOrder = (row: any): string => {
  if (Array.isArray(row?.lines) && row.lines.length) {
    return row.lines
      .map((line: any) =>
        [line?.colour, line?.quantity != null ? `×${line.quantity}` : ""]
          .filter(Boolean)
          .join(" ")
      )
      .filter(Boolean)
      .join(", ");
  }
  if (row?.colour || row?.quantity != null) {
    return [row.colour, row.quantity != null ? `×${row.quantity}` : ""]
      .filter(Boolean)
      .join(" ");
  }
  return "";
};

export const dueDateLabel = (value: any): string => {
  if (!value) {
    return "";
  }
  const raw = String(value);
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    return raw.slice(0, 10);
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "";
  }
  return parsed.toISOString().slice(0, 10);
};

export const orderToOption = (row: any): StudioOrderOption | null => {
  const id = geoRecordId(row);
  const code = String(row?.orderCode || "").trim();
  if (!id && !code) {
    return null;
  }
  const customerName = String(row?.customerName || "").trim();
  const productDesign = String(row?.productDesign || "").trim();
  const colours = coloursFromOrder(row);
  const status = String(
    row?.workflowStatusLabel ||
      workflowLabel(row?.workflowStatus, row?.customStageLabel)
  );
  const dueDate = dueDateLabel(row?.dueDate);
  const orgName = String(row?.orgName || "").trim();
  const label = [code || id, customerName, productDesign, colours, status]
    .filter(Boolean)
    .join(" · ");
  return {
    value: id || code,
    label,
    code: code || id,
    customerName,
    productDesign,
    colours,
    status,
    dueDate,
    orgName,
  };
};

export const fallbackOrderOption = (id?: string, code?: string): StudioOrderOption | null => {
  const value = String(id || "").trim();
  const orderCode = String(code || "").trim();
  if (!value && !orderCode) {
    return null;
  }
  const label = orderCode || value;
  return {
    value: value || orderCode,
    label,
    code: orderCode || value,
    customerName: "",
    productDesign: "",
    colours: "",
    status: "",
    dueDate: "",
    orgName: "",
  };
};
